<container-element [ngSwitch]="type">
  <div *ngSwitchCase="'teacher-calendar'">
    <div
      routerLink="/teacher/calendar"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
      <mat-icon svgIcon="calendar"></mat-icon>
      {{ "calendar" | translate }}
    </div>
    <div
      routerLink="/teacher/calendar/availability"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
      <mat-icon svgIcon="user-gear"></mat-icon>
      {{ "configure-availability" | translate }}
    </div>
  </div>

  <div *ngSwitchCase="'teacher-profile'">
    <div
      routerLink="/teacher/settings"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    ><mat-icon>info</mat-icon>
      {{ "about" | translate }}
    </div>
    <div
        routerLink="/teacher/settings/premium-billing"
        routerLinkActive="activated"
        class="sidenav-link"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="isMobile ? sideNav.toggle() : ''"
      >
      <mat-icon>workspace_premium</mat-icon>
        {{ "premium-billing" | translate }}
      </div>
      <div
      routerLink="/teacher/settings/subjects"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
    <mat-icon>fact_check</mat-icon>
      {{ "subjects-to-teach" | translate }}
    </div>
    <div
      routerLink="/teacher/settings/certificates"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    ><mat-icon>workspace_premium</mat-icon>
      {{ "certificates" | translate }}
    </div>
  </div>

  <!-- Student -->
  <div *ngSwitchCase="'student-zone'">
    <div
      routerLink="/student/settings/index"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
      <mat-icon svgIcon="user-solid"></mat-icon>
      {{ "profile" | translate }}
    </div>
    <div
      routerLink="/student/settings/calendar"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
      {{ "calendar" | translate }}
    </div>
    <div
      routerLink="/student/settings/classes"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
      {{ "my-classes" | translate }}
    </div>
    <div
      routerLink="/student/settings/wallet"
      routerLinkActive="activated"
      class="sidenav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="isMobile ? sideNav.toggle() : ''"
    >
      {{ "my-payments" | translate }}
    </div>
  </div>

  <!-- Student -->
  <div *ngSwitchCase="'chat-list'">
    <app-chat-list></app-chat-list>
  </div>
</container-element>
